export const ROUTES = {
  ROOT: '/',
  REGISTER: '/register',
  ACTIVATE_EMAIL: '/activate',
  VERIFY_EMAIL: '/auth/verify',
  BOOK: '/book',
  LIBRARY: '/library',
  STUDENT: '/insights/student',
  CLASS: '/insights/class',
  CLASSES: '/classes',
  CLASSES_CREATE: '/classes/create',
  REQUEST_PASSWORD_RESET: '/auth/reset-pass',
  RESET_PASSWORD: '/auth/reset-pass/:resetToken',
  INSIGHTS: '/insights',
  PROFILE: '/profile'
}
